"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var erpInfo_1 = require("./erpInfo");
var paxField_1 = require("./paxField");
var PaxElement = /** @class */ (function () {
    function PaxElement(isBuyer) {
        this.isBuyer = false;
        this.sex = new paxField_1.PaxField('sex', 'select', 'Anrede');
        this.firstName = new paxField_1.PaxField('firstName', 'text', 'Vorname');
        this.lastName = new paxField_1.PaxField('lastName', 'text', 'Nachname');
        this.birthday = new paxField_1.PaxField('birthday', 'text', 'Geburtsdatum');
        this.nationalityCode = new paxField_1.PaxField('nationalityCode', 'select', '');
        this.erpConfirm = new paxField_1.PaxField('erpConfirm', 'checkbox', '');
        this.erpInfo = new erpInfo_1.ErpInfo(null, null, null);
        this.erpInfos = [
            new erpInfo_1.ErpInfo(null, null, null),
            new erpInfo_1.ErpInfo(null, null, null),
        ];
        this.isBuyer = isBuyer;
    }
    return PaxElement;
}());
exports.PaxElement = PaxElement;
//# sourceMappingURL=pax.js.map